export default {
    applyChargeCarrier:
        "/gateway/huilianCharge/chargeCarrierApplycs/applyChargeCarrier", //运营商申请审核
    selectChargeCarrierApplyStatus:
        "/gateway/huilianCharge/chargeCarrierApplycs/selectChargeCarrierApplyStatus", //审核状态查询
    myChargeCarrierDetail:
        "/gateway/huilianCharge/chargeCarriercs/myChargeCarrierDetail", //运营商详情
    getInviteQrCodeDetail:
        "/gateway/huilianCharge/chargeCarrierInvitecs/getInviteQrCodeDetail", //获取邀请二维码详情
};



// WEBPACK FOOTER //
// ./src/yysChargingOperator/index/api.js